import { DataUtilLocalStorage } from "../../../../data/utils/LocalStorage";
import { Vector } from "../FloatingBubble";

export class FloatingBubbleStorage {
    private storageKey: string | null = null;
    private lastPosition: Vector | null = null;

    constructor() { }

    public get _LastPosition(): Vector | null {
        return this.lastPosition ? { ...this.lastPosition } : null;
    }

    public get _StorageKey(): string {
        return this.storageKey;
    }

    public set _StorageKey(storageKey: string | number) {
        this.storageKey = storageKey?.toString() || null;

        if (!this.storageKey) {
            this.lastPosition = null;
            return;
        }

        const storageData = this._GetStoragePosition();
        if (storageData) {
            this.lastPosition = storageData;
        }
    }

    public _GetStoragePosition(): Vector | null {
        const storageKey = this.storageKey;
        if (!storageKey) return null;

        const data = DataUtilLocalStorage._GetItem('floatingBubbleComponentPosition', `${storageKey}`);
        const lastPosition = data ? JSON.parse(data) : null;

        return lastPosition;
    }

    public _SetStoragePosition(positions: Vector) {
        const storageKey = this.storageKey;
        if (!storageKey) return;

        for (const key in positions) {
            if (this.lastPosition) {
                this.lastPosition[key] = positions[key];
            } else {
                this.lastPosition = { ...positions };
            }
        }
        DataUtilLocalStorage._SetItem('floatingBubbleComponentPosition', `${storageKey}`, JSON.stringify(this.lastPosition));
    }
}